import React from "react";

const Header = () => {
  return (
    <nav className="navbar navbar-dark bg-dark">
      <div className="container-fluid ">
        <span className="navbar-brand mb-0 h1">
          Gallery App
        </span>
      </div>
    </nav>
  );
};

export default Header;
